import { useInfiniteQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { handleQueryError } from "@js2/modules/network/util";
import { ErrorResponse } from "@js2/requests/@types";
import { UrlReport } from "@modules/network/@types";
import { IPWithIdPagingRequest } from "@modules/network/@types/IP";
import api from "@modules/network/api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "@modules/network/consts";

export type Response = { reports: Array<UrlReport>; next_page?: string };

const useEnrichedIpUrls = ({
  ip = "",
  page_size = 10
}: IPWithIdPagingRequest) =>
  useInfiniteQuery({
    initialPageParam: "",
    enabled: Boolean(ip),
    queryKey: ["enriched-ip-urls", ip, page_size],
    queryFn: ({ pageParam, signal }) =>
      api
        .enrichedIpUrls({ ip, page: pageParam, page_size }, signal)
        .then((r: AxiosResponse<Response>) => r.data)
        .catch((e: ErrorResponse) => handleQueryError(e, "ip related URLs")),
    getNextPageParam: lastPage => lastPage?.next_page ?? undefined,
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });

export default useEnrichedIpUrls;
